import Dictionary from "./components/Dictionary"
import './App.css'

function App() {

  return (
    <>
      <Dictionary />
    </>
  );
}

export default App;